/**
 * WireGeometryEditCommand.js
 * Wire vertex sürükleme (köşe vertex + panel çıkış swap) undo/redo komutu.
 *
 * wires: [{id, before:[{x,y,z}], after:[{x,y,z}]}]
 *   - Sürüklenen ana wire + swap olan diğer wire'lar + bağlı lighting/fixture wire'ları
 * components: [{id, before:{x,y,z}, after:{x,y,z}}]
 *   - Wire üzerindeki socket/buat/makina gibi komponent pozisyon değişimleri
 */

import BaseCommand from './BaseCommand';

class WireGeometryEditCommand extends BaseCommand {
  constructor(wires, components = []) {
    super('WIRE_GEOMETRY_EDIT', { before: null, after: null });
    this.wires = wires;
    this.components = components;
  }

  execute(scene, dispatch) {
    this._apply(scene, 'after');
  }

  undo(scene, dispatch) {
    this._apply(scene, 'before');
  }

  _apply(scene, stateKey) {
    const wireMap = new Map(this.wires.map(w => [w.id, w[stateKey]]));
    const compMap = new Map(this.components.map(c => [c.id, c[stateKey]]));

    scene.traverse(obj => {
      const id = obj.userData?.id;
      if (!id) return;

      if (wireMap.has(id) && obj.isLine) {
        const pos = obj.geometry?.attributes?.position;
        if (pos) {
          const verts = wireMap.get(id);
          const count = Math.min(verts.length, pos.count);
          for (let i = 0; i < count; i++) {
            pos.setXYZ(i, verts[i].x, verts[i].y, verts[i].z);
          }
          pos.needsUpdate = true;
          obj.geometry.computeBoundingSphere();
        }
      }

      if (compMap.has(id)) {
        const p = compMap.get(id);
        obj.position.set(p.x, p.y, p.z);
      }
    });
  }
}

export default WireGeometryEditCommand;
